module.exports = "<div class=\"text-center\" ng-if=\"(!$ctrl.filterData.filterData.cells.length && !$ctrl.filterData.loading\n     && !$ctrl.filterData.cancelled) || !$ctrl.hasData\">{{::'Нет данных за период, попадающих под фильтр' | gettext}}</div>"


//////////////////
// WEBPACK FOOTER
// ./src/stat/event-river/event-river.component.html
// module id = 942
// module chunks = 0